import WebpackerReact from 'webpacker-react'

import N2StylesModal from '../components/N2StylesModal'
import N2StylesModalAuto from '../components/N2StylesModalAuto'
import ArticlePubFilter from '../components/ArticlePubFilter'
import AreaDirectorSortableArticleJobsList from '../react/AreaDirectorSortableArticleJobsList'
import ShareArticleHandler from '../components/ShareArticleHandler'
import ChevronToggle from '../components/ChevronToggle'
import SelectizeWithCreate from '../components/SelectizeWithCreate'
import SaveOnNavigate from '../components/SaveOnNavigate'
import FroalaEditor from "../components/editor/FroalaEditor"
import ReuseArticle from "../react/ReuseArticle"
import ArticlePlacementForm from "../components/ArticlePlacementForm"
import EventArticle from "../react/EventArticle"

export default class ArticleJobs {
  constructor(params) {
    WebpackerReact.setup({ReuseArticle, EventArticle})
    this.params = params;
    this.role = params.role || null
  }

  unload() {
    if (this.shareArticle) { this.shareArticle.unload() }
  }

  assetUploadUrl() {
    return '/article_jobs/' + this.params.id + '/assets';
  }

  new() {
    this.bindAutoSubmitNewArticle();
  }

  index() {
    if (this.role == "area_director") {
      this.bindDeadlineExtension()
      this.bindManualSubmission()
      this.allFilter = new ArticlePubFilter({territoryId: this.params.territoryId, selector: "#filter-article-pubs"});
      let keys = ["shared", "complete", "incomplete"];
      let klass = AreaDirectorSortableArticleJobsList;
      this.sortArticles(keys, klass)
    }
  }

  show() {
    if (this.role == "area_director") {
      ['.js-mark-article-complete', '.js-reuse-article'].forEach((selector) => {
        N2.handle("click", selector, (evt) => {
          new N2StylesModal(selector + "-modal");
        })
      });
      if (this.shareArticle) { this.shareArticle.unload() }
      this.shareArticle = new ShareArticleHandler()
      this.shareArticle.init()

      N2.handle("click", '.js-share-submit', (evt) => {
        this.shareArticle.sendForm($(evt.currentTarget).data('url'))
      })
      N2.bindHandler('click', '.auto-select', function(e) {
        new SelectText($(this).data('selector'));
      });
    }
    new ChevronToggle();
    if ($("a[href='#article-photos']").length) {
      new OfficeUserShow()
    }
  }

  edit() {
    this.togglePubPlacementControl();
    new SelectizeWithCreate();

    // Bind global handlers.
    this.bindSponsorshipVisibilityToggle();
    new SaveOnNavigate();
    this.bindLoadingIndicator();

    N2.bindGlobalHandler("pm:replace-article-placements", (evt) => {
      this.detailsCardUpdate(evt.detail)
    });
  }

  // Page init that needs to be re-run when elements on the page change, see
  // views/article_jobs/update.js.erb
  detailsCardUpdate({ html, errors }) {
    new ArticlePlacementForm({ html, errors, callback: () => {
      this.togglePubPlacementControl();
      new SelectizeWithCreate();
    }})
  }

  bindLoadingIndicator() {
    $("form.edit_article_job").
      on("ajax:send", () => {
        N2.showProgressIndicator()
      }).
      on("ajax:success", function() {
        if ($(this).data('toast')) {
          toastr.options["positionClass"] = "toast-bottom-center";
          toastr["info"]("Saved successfully!");
        }
      }).
      on("ajax:error", function() {
        if ($(this).data('toast')) {
          toastr.options["positionClass"] = "toast-bottom-center";
          toastr["info"]("Something went wrong, please try again.");
        }
      }).
      on("ajax:complete", function() {
        if ($(this).data('dismiss') == "loading") {
          N2.hideProgressIndicator()
        }
      })
  }

  togglePubPlacementControl() {
    if (!this.params.swapPubControls) { return }

    if (this.params.multiplePubs) {
      $("input[type='radio']").attr("type", "checkbox").removeClass("with-gap");
    } else {
      $("input[type='checkbox']").not("#article_job_resident_article").attr("type", "radio").addClass("with-gap");
    }
  }

  setupRichTextEditor() {
    this.richTextEditor = new FroalaEditor();
    this.richTextEditor.init();
    this.manuallyFixBodyTextFieldLabel();
  }

  text() {
    this.setupRichTextEditor()
    this.bindBylineHandlers();
    this.bindCTAModal()
    new SaveOnNavigate();
    this.bindLoadingIndicator();
  }

  requests() {
    this.setupRichTextEditor()
    new SaveOnNavigate();
    this.bindLoadingIndicator();
    this.bindPlacementConfirmModal();
  }

  update() { this.edit() }

  listings() {
    new N2Styles.searchBar({
      safeContainer: ".js-listings-search",
      showSelector: ".js-search",
    });
  }

  bindManualSubmission() {
    N2.handle("click", '.js-submit-articles', (evt) => {
      new N2StylesModal(".js-manual-submit-modal")
      $('.js-confirm-submit').attr('data-id', $(evt.currentTarget).data('id'))
    })
    N2.handle("click", '.js-confirm-submit', (evt) => {
      $(`.js-manual-submit-form-${$(evt.currentTarget).data('id')}`).submit()
    })
  }

  bindDeadlineExtension() {
    N2.handle("click", '.js-extend-deadline', (evt) => {
      new N2StylesModal(".js-extend-deadline-modal")
      $('.js-confirm-extension').attr('data-id', $(evt.currentTarget).data('id'))
    })
    N2.handle("click", '.js-confirm-extension', (evt) => {
      $(`.js-extension-form-${$(evt.currentTarget).data('id')}`).submit()
    })

    N2.handle("click", '.js-end-deadline-extension', (evt) => {
      evt.preventDefault();
    })

    new N2StylesModalAuto(".js-end-deadline-extension");
  }

  bindCTAModal() {
    N2.handle("click", ".js-add-cta", (evt) => {
      new N2StylesModal(".js-add-cta-modal")
    })
    N2.handle("click", ".js-cta-option", (evt) => {
      $('.js-cta-option.blue').removeClass('blue text-white').addClass('grey lighten-3')
      $(evt.currentTarget).removeClass('grey lighten-3').addClass('blue text-white')
    })

    N2.handle("click", ".js-cta-selected", (evt) => {
      let val = $('.js-cta-option.blue p').text()
      $('.js-cta-option.blue').removeClass('blue text-white').addClass('grey lighten-3')
      $(".js-add-cta-modal").modal('hide')
      $('#article_job_call_to_action').focus()
      $('#article_job_call_to_action').val(val)
    })
  }

  bindAutoSubmitNewArticle() {
    N2.handle("click", ".js-article-type-choice", function(evt) {
      var type = $(evt.target).data('articleType');
      $("#article_job_article_type").val(type);
      $(this).closest("form").submit();
    });
  }

  bindSponsorshipVisibilityToggle() {
    N2.bindHandler("change", "[type=checkbox][name='article_job[placement_publication_ids][]']", (evt) => { // eslint-disable-line
      const $target = $(evt.target);
      if (this.params.pubTypeSponsorsEnabled) {
        if (this.params.pubIdsWithSponsors.includes($target.val())) {
          this.handleSelectedPub($target);
        }
      } else {
        this.handleSelectedPub($target);
      }
    });

    N2.bindHandler("change", ".js-sponsorship-select", (evt) => { // eslint-disable-line
      const $ele = $(evt.target);
      const shouldDestroy = ["No Sponsorship"].includes($ele.val());
      const $destroy = $(".js-destroy", $ele.closest(".hidden-sponsorship-select"));
      $destroy.val(shouldDestroy);
    });
  }

  handleSelectedSponsor($ele) {
    const pubid = $ele.val();
    const id = `select.selectize[data-publication-id='${pubid}']`;
    const otherPubs = $("select.js-sponsorship-select").not(id);
    otherPubs.each((_, e) => e.selectize.addItem("No Sponsorship", true));
  }

  handleSelectedPub($ele) {
    let pubid = $ele.val();
    let checked = $ele.prop('checked');
    let id = `select.selectize[data-publication-id='${pubid}']`
    let parent = $(id).closest(".md-form");
    $('.selectize-dropdown', parent).toggleClass("hidden", !checked);
    $('.selectize-control', parent).toggleClass("hidden", !checked);
  }

  sortArticles(keys, klass) {
    var data;
    keys.forEach((ele) => {
      if ($(`.js-articles-react-data-${ele}`).length) {
        data = $(`.js-articles-react-data-${ele}`).data("jobs");
        let list = new klass({
          sortScope: `#sort-filters-${ele}`,
          selector: `.js-articles-list-${ele}`,
          data: data,
          roleType: this.role
        });
        if (this.allFilter !== undefined) {
          this.allFilter.addList(ele, data, list);
        }
        list.render()
      }
    });
  }

  bindBylineHandlers() {
    N2.handle("click", ".js-add-byline", (evt) => {
      let $ele = $(".byline-template").clone().appendTo(".bylines").removeClass("hidden").removeClass("byline-template");
      $("label", $ele).addClass("active");
      $("input", $ele).val("By ").focus();
    })
    // Global because we're putting new elements onto the page.
    N2.bindGlobalHandler("click", ".js-remove-byline", function() {
      $(this).closest('.md-form').remove();
    })
  }

  manuallyFixBodyTextFieldLabel() {
    N2.handle("click", "label[for='article_job_text']", () => {
      this.richTextEditor.focus();
    });

    this.richTextEditor.focusListener(function(e, editor) {
      $('label[for="article_job_text"]').addClass("active");
    });

    this.richTextEditor.blurListener(function(e, editor) {
      let $lbl = $('label[for="article_job_text"]')
      if (editor.core.isEmpty()) {
        $lbl.removeClass("active");
      }
    });
  }

  // When an article is chosen to be featured / optional on the Requests step
  // of the Article workflow, and a different article for the same pub and
  // month is already featured / optional, we need to show a confirmation modal
  // to alert them that the special placement choice article is changing.
  bindPlacementConfirmModal() {
    N2.bindGlobalHandler("click", '.js-article-save', (evt) => {
      const form = $('form.edit_asset');
      if ($('.js-featured-article-modal').length > 0 && $('#article_job_placement_request_featured:checked').length > 0) {
        evt.preventDefault();
        new N2StylesModal(".js-featured-article-modal");

      } else if ($('.js-optional-article-modal').length > 0 && $('#article_job_placement_request_optional:checked').length > 0) {
        evt.preventDefault();
        new N2StylesModal(".js-optional-article-modal");
      } else {
      }
    })

    N2.handle("click", '.js-featured-confirm, .js-optional-confirm', (evt) => {
      N2.showProgressIndicator();
      $('form.edit_article_job').submit();
    })
  }
}
